import { constants } from "../../../constants";
import { PxTalk } from "../../../types/bwic/PxTalk";
import { formatUtils, numericUtils } from "../../../utils";

interface Props {
    priceTalks?: PxTalk[]
}
export function PxTalkDmRangeText({ priceTalks }: Props) {
    if (!priceTalks?.some(p => numericUtils.isNumber(p.dm))) return <>{constants.emptyPlaceholder}</>;

    const dmValues = priceTalks
        .map(p => numericUtils.isNumber(p.dm) ? numericUtils.round(+p.dm, 0) : null)
        .filter(dm => dm != null) as number[];

    const min = Math.min(...dmValues);
    const max = Math.max(...dmValues);

    return (
        <>
            {min === max
                ? formatUtils.formatDiscountMargin(min)
                : `${formatUtils.formatDiscountMargin(min)} - ${formatUtils.formatDiscountMargin(max)}`}
        </>);
}